
import { useEffect } from 'react'
import './App.css'
import './index.css'
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './components'
import Navbar from './components/Navbar/Navbar'
import Footer from './components/Footer/Footer'
import Home from './pages/Home'
import Book from './pages/Book'
import Login from './pages/Login'
import Register from './pages/Register'
import Account from './pages/Account'
import Reviews from './pages/Reviews'
import Contact from './pages/Contact'

/* ── Scroll-reveal IntersectionObserver ── */
function ScrollRevealInit() {
  const { pathname } = useLocation();

  useEffect(() => {
    let io;
    let mo;

    const timeout = setTimeout(() => {
      io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('revealed');
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
      );

      /* Observe an element if it hasn't been revealed yet */
      const track = (el) => {
        if (!el.classList.contains('revealed')) {
          io.observe(el);
        }
      };

      /* Initial sweep */
      document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach((el) => {
        el.classList.remove('revealed');
        track(el);
      });

      /* Watch for dynamically-added [data-reveal] elements (e.g. after async fetch) */
      mo = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          m.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            if (node.hasAttribute?.('data-reveal') || node.hasAttribute?.('data-reveal-stagger')) {
              track(node);
            }
            node.querySelectorAll?.('[data-reveal], [data-reveal-stagger]').forEach(track);
          });
        });
      });

      mo.observe(document.body, { childList: true, subtree: true });
    }, 100);

    return () => {
      clearTimeout(timeout);
      if (io) io.disconnect();
      if (mo) mo.disconnect();
    };
  }, [pathname]);

  return null;
}

/* ── Scroll to top on route change ── */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollRevealInit />
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route index element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/rent' element={<Book />} />
          <Route path='/reviews' element={<Reviews />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/account' element={
            <ProtectedRoute>
              <Account />
            </ProtectedRoute>
          } />
          <Route path='*' element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App